import Vuex from "vuex";
import documentModel from "@/services/word/documentModelService";
import addinSettings from "@/services/common/addinSettingsService";

const _settings = addinSettings.get();

const createStore = () => new Vuex.Store({
    state: {
        connected: false,
        loggedIn: false,
        currentDocument: "",
        currentTemplates: [],
        currentPlaceholder: null,
        documentModel: null,
        error: "",
        contentSelected: false,
        expertMode: _settings.expertMode,
        diagnosticsEnabled: _settings.diagnosticsEnabled,
        boundingBoxesHidden: _settings.boundingBoxesHidden,
        profileLoaded: false
    },
    mutations: {
        loggedIn(state) {
            state.loggedIn = true;
        },
        loggedOut(state) {
            state.loggedIn = false;
        },
        connected(state) {
            state.connected = true;
        },
        disconnected(state) {
            state.connected = false;
        },
        currentDocument(state, payload) {
            state.currentDocument = payload.document;
        },
        currentTemplates(state, payload) {
            state.currentTemplates = payload.templates;
        },
        currentPlaceholder(state, payload) {
            state.currentPlaceholder = payload.placeholder;
        },
        documentModel(state, payload) {
            state.documentModel = payload.model;
        },
        error(state, payload) {
            state.error = payload.message
        },
        clearError(state) {
            state.error = ""
        },
        contentSelected(state, payload) {
            state.contentSelected = payload.selected;
        },
        expertMode(state, payload) {
            state.expertMode = payload.enabled;
        },
        diagnosticsEnabled(state, payload) {
            state.diagnosticsEnabled = payload.enabled
        },
        boundingBoxesHidden(state, payload) {
            state.boundingBoxesHidden = payload.hide
        },
        profileLoaded(state) {
            state.profileLoaded = true;
        }
    },
    actions: {
        saveDocumentModel: async function ({ commit }, model) {
            try {
                await documentModel.save(model);
                commit("documentModel", { model });
            } catch (error) {
                commit("error", { message: error });
            }
        },
        enableExpertMode: function ({ commit }, enabled) {
            const settings = addinSettings.get();

            settings.expertMode = enabled;
            addinSettings.set(settings);

            commit("expertMode", { enabled });
        },
        enableDiagnostics: function ({ commit }, enabled) {
            const settings = addinSettings.get();

            settings.diagnosticsEnabled = enabled;
            addinSettings.set(settings);

            commit("diagnosticsEnabled", { enabled });
        },
        hideBoundingBoxes: function ({ commit }, hide) {
            const settings = addinSettings.get();

            settings.boundingBoxesHidden = hide;
            addinSettings.set(settings);

            commit("boundingBoxesHidden", { hide });
        }
    }
});

const create = () => {
    return createStore();
};

export default {
    create
};